import type { URN } from "../../../types";
import type {
  BetslipExchangeMarket,
  BetslipExchangeMarketRecord,
  BetslipExchangeRunnerTree,
  ExchangeMarketsReadState,
} from "./ExchangeMarkets.types";

const getMarketRecordForRunner = (
  state: ExchangeMarketsReadState,
  runnerUrn: URN,
): BetslipExchangeMarketRecord | undefined => {
  const marketUrn = state.exchangeMarkets?.marketByRunner[runnerUrn];

  return marketUrn ? state.exchangeMarkets?.byMarket[marketUrn] : undefined;
};

export const getExchangeMarket = (state: ExchangeMarketsReadState, marketUrn: URN): BetslipExchangeMarket | undefined =>
  state.exchangeMarkets?.byMarket[marketUrn]?.market;

export const getExchangeMarketForRunner = (
  state: ExchangeMarketsReadState,
  runnerUrn: URN,
): BetslipExchangeMarket | undefined => {
  const record = getMarketRecordForRunner(state, runnerUrn);

  return record?.runners[runnerUrn] ? record.market : undefined;
};

export const getExchangeRunnerTree = (
  state: ExchangeMarketsReadState,
  runnerUrn: URN,
): BetslipExchangeRunnerTree | null => {
  const record = getMarketRecordForRunner(state, runnerUrn);
  const runner = record?.runners[runnerUrn];
  const marketRunner = record?.market.runners.find(({ urn }) => urn === runnerUrn);

  if (!record || !runner || !marketRunner) {
    return null;
  }

  return { runner, marketRunner, market: record.market };
};
